export { default } from './QuoteBlock';
export type { Props, Props as QuoteBlockProps } from './QuoteBlock';
